import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector   : 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls  : ['./confirm-dialog.component.scss']
})
export class FuseConfirmDialogComponent implements OnInit
{
    public confirmMessage: string;
    public message: string;
    public title: string;
    public confirm: boolean = false;
    translations: any;
    
    constructor(public dialogRef: MatDialogRef<FuseConfirmDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data: any){
        this.setPageTranslations();
    }

    ngOnInit()
    {
    }

    setPageTranslations(){
      this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
    }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/core/components/confirm-dialog/confirm-dialog.component.ts